export enum ProjectStage {
  STAGE_CREATOR = 'project-creator',
  STAGE_CREATED = 'created',
  STAGE_MEETING = 'meeting',
  STAGE_ESTIMATE = 'estimate',
  STAGE_NEGOTIATIONS = 'negotiations',
  STAGE_PLANNING = 'planning',
  STAGE_WON = 'won',
  STAGE_BEFORE_REALIZATION = 'before-realization',
  STAGE_BEFORE_EXECUTION = 'before-execution',
  STAGE_REALIZATION = 'realization',
  STAGE_APPROVED = 'approved',
  STAGE_PAYMENT = 'payment',
  STAGE_FINISHED = 'finished',
  STAGE_COMPLAINT = 'complaint',
  STAGE_LOST = 'lost'
}
